module.exports = __webpack_public_path__ + "img/forex-trading-3.e1b83559.png";